import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Spinner from '../../../../components/Spinner'
import { contentModerationReviews } from '../../../../../redux/actions/admin';
import ReviewsReports from './Reviews&Reports'
import { Container, Reviews } from './ContentModerationStyled'
import { SelectWrapper } from '../DashBoard/dashBoardStyled';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

function ContentModeration() {
    let location = useLocation();
    const dispatch = useDispatch();
    let history = useHistory()
    const [modal, setModal] = useState(false);
    const [modalMessage, setModalMessaage] = useState('')
    const [userType, setUserType] = useState('BUYER')
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [abusePage, setAbusePage] = useState(1);
    const [tabValue, setTabValue] = useState(0);
    const adminRoles = useSelector(state => state.admin.adminRoles)

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        if (location.state !== null && location.state !== undefined) {
            setPage(location.state.page)
            setAbusePage(location.state.abusePage)
            setTabValue(location.state.tabValue)
        }
    }, []);

    useEffect(() => {
        fetchMyAPI();
    }, [userType]);

    const fetchMyAPI = async () => {
        let response = '';
        response = await dispatch(contentModerationReviews(userType));
        if (response.status === 'SUCCESS') {
            if (response.payload) {
                let adminReviewDataList = response.payload
                setDataList(adminReviewDataList)
            }
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response.message)
                setModal(!modal)
            }
        }
    };

    const selectStyle = {
        border: 'none',
    }

    const handleToggle = () => {
        setModal(false)
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('CONTENT_MODERATION_ADMIN'))) ?
                <Container>
                    {loaderVisible && <Spinner />}
                    <TableWrapper>
                        <Heading>
                            <h3>Content Moderation</h3>
                            <SelectWrapper>
                                <select placeholder='User Type' id='usereType' style={selectStyle} value={userType} onChange={e => {
                                    setPage(1)
                                    setAbusePage(1)
                                    setUserType(e.target.value)
                                }}>
                                    <option value='BUYER'>Buyer</option>
                                    <option value='SELLER'>Seller</option>
                                </select>
                            </SelectWrapper>
                        </Heading>
                        <Reviews>
                            <ReviewsReports data={dataList} func={fetchMyAPI} page={page} abusePage={abusePage} tabValue={tabValue} />
                        </Reviews>
                    </TableWrapper>

                    <Modal isOpen={modal} centered={true}>
                        <ModalBody style={{ textAlign: 'center' }}>
                            {modalMessage}
                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>
                </Container>
                :
                <p>You are not authorized to view this page.</p>
            }
        </>

    )

}

export default ContentModeration